import { Box, Button, makeStyles, Menu, MenuItem, Typography } from "@material-ui/core";
import Cookies from "js-cookie";
import { observer } from "mobx-react-lite";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import React from "react";

import { StoreContext } from "../../store";
import FlagIcon from "../atoms/FlagIcon";
import { Check, KeyboardArrowDown } from "@material-ui/icons";

const LANGUAGES = [
  { key: "en-us", locale: "en", label: "English", countryCode: "US" },
  { key: "id-id", locale: "id", label: "Indonesia", countryCode: "ID" },
];

const useStyles = makeStyles((theme) => ({
  button_language: {
    textTransform: "none",
    padding: "0", // "4px 8px",
    marginLeft: 12,
    minWidth: "auto",
    "&:hover": {
      backgroundColor: "transparent", // ❌ remove grey hover
    },
  },
}));

export default observer(function LanguageSelector({ ...props }) {
  const { t } = useTranslation("common");
  const router = useRouter();
  const classes = useStyles();
  const store = React.useContext(StoreContext);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = React.useCallback(
    async (locale) => {
      Cookies.set("NEXT_LOCALE", locale, { expires: 365 });

      if (store.organization.selected) {
        store.organization.selected.locale = locale;
        await store.organization.update(store.organization.selected);
      }
      const { pathname, asPath, query } = router;
      router.push({ pathname, query }, asPath, { locale });

      handleClose();
    },
    [store.organization, router, handleClose]
  );

  const selectedLanguage = React.useMemo(() => {
    const language = LANGUAGES.find(({ locale }) => locale === router.locale);
    return language ?? LANGUAGES[0];
  }, [router]);

  return (
    <React.Fragment>
      <Button
        className={classes.button_language}
        variant="text"
        onClick={handleMenu}
        {...props}
        // endIcon={<KeyboardArrowDown />}
      >
        <FlagIcon countryCode={selectedLanguage.countryCode} />
        <KeyboardArrowDown fontSize="small" />
      </Button>
      <Menu
        keepMounted
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
      >
        {LANGUAGES.map(({ key, locale, countryCode, label }) => {
          const isSelected = selectedLanguage?.locale === locale;

          return (
            <MenuItem
              key={key}
              selected={isSelected}
              onClick={() => handleChange(locale)}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 36,
              }}
            >
              <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                <FlagIcon countryCode={countryCode} />
                <Typography>{label}</Typography>
              </Box>
              {isSelected && <Check style={{ color: "#55a630" }} />}
            </MenuItem>
          );
        })}
      </Menu>
    </React.Fragment>
  );
});
